import * as $ from "jquery";
import imkt from '../../../imkt';
import general from '../../../utils/general';

var isMobile = function () {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent
  );
};

// ==========================================================================
// On document ready
// ==========================================================================

$(function () {
  var userTierSelect = $('[name^="usersSelectDropdown"]');
  if (userTierSelect.length && !isMobile()) {
    $.getScript(
      imkt.constants.libPath + "select2.js" + imkt.constants.cdnVersionQuery
    ).done(function () {
      userTierSelect.select2({ minimumResultsForSearch: -1 });
    });
  }

  userTierSelect.on("change", function () {
    var optionValue = $(this).val().split(",");
    var userCount = optionValue[0];
    var price = optionValue[1];
    var bitbucketRegex = /(\d+|unlimited)(?=_users)/i;

    $(this)
      .parents(".pricing-column")
      .find(".monthlyPricing")
      .text(general.numberWithCommas(price));

    if ($(".pricing-column.cloud").is(":visible")) {
      var button = $(this).parents(".pricing-column.cloud").find("a.button");
      button.attr(
        "href",
        button.attr("href").replace(bitbucketRegex, userCount)
      );
    }
  });
}); // end document ready
